<template>
  
    <the-header></the-header>
  
    <call-slip></call-slip>
    
    
    <the-footer/>
  </template>
  
  <script>
import CallSlip from "./CallSlip.vue";

export default{
  components:{ CallSlip }
  }
  </script>
  
  <style scoped>
  
  </style>